export default __webpack_public_path__ + "static/media/tensorflow-text.5f848fdc.svg";